import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    root: {
        minWidth: 220,
    },
    input: {
        paddingTop: 13,
        paddingBottom: 12,
    },
    formControl: {
        top: -6,
    },
    shrink: {
        top: 0,
    },
    textFieldMargin: {},
}));
